// extracted by mini-css-extract-plugin
module.exports = {"noticeMessage":"UpdatePhoneNumber_noticeMessage__2SZWE","buttons":"UpdatePhoneNumber_buttons__2Mrqa"};